// @flow

const tagEditableStyles = {
  // Container style (uses same as TagRenderer)
  tagsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    alignItems: 'center'
  },
  
  // Add tag button
  addTagButton: (theme, size, showOnlyAddButton = false) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    color: '#666',
    fontSize: size === 'small' ? '0.75rem' : '0.875rem',
    height: size === 'small' ? '20px' : '24px',
    width: size === 'small' ? '20px' : '24px',
    padding: 0,
    borderRadius: '24px',
    marginLeft: showOnlyAddButton ? 0 : '4px',
    cursor: 'pointer',
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    border: '1px solid #ddd',
    opacity: 0.6,
    transition: 'opacity 0.2s ease'
  }),
  
  // Add tag icon
  addTagIcon: {
    fontSize: '20px',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  },
  
  // Legacy support
  addTagChip: {
    backgroundColor: '#f5f5f5',
    color: '#666',
    borderStyle: 'dashed',
    borderWidth: '1px',
    borderColor: '#ccc',
    '&:hover': {
      backgroundColor: '#e0e0e0',
      borderColor: '#999'
    }
  }
};

export default tagEditableStyles; 